import axios from "axios";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Checkbox as PrimeReactCheckBox } from "primereact/checkbox";
import { classNames } from "primereact/utils";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../../stateManagement/hooks/redux";
import { getItemWebStorage, setItemWebStorage } from "../../../../../features/webStorageSaver";
import { capitalize, checkLastMonth, checkLastWeek, checkLastYear, checkThisMonth, checkThisWeek, checkThisYear, checkToday, checkYesterday, convertDate, formatDate } from "../../../../../features/dataFormatFunctions/dataFormatter";
import { setRoadAccidentsActiveFiltersTabs, setRoadAccidentsAllRaionMapFilterValues, setRoadAccidentsInfo, setRoadAccidentsMapFilters } from "../../../../../stateManagement/reducers/objectTypes/RoadAccidentsSlice";
import { store } from "../../../../../stateManagement/store";
import { setLastMonthDateFilterRange, setLastWeekDateFilterRange, setLastYearDateFilterRange, setThisMonthDateFilterRange, setThisWeekDateFilterRange, setThisYearDateFilterRange, getTodayDateFilterRange, setYesterdayDateFilterRange } from "../customMapOverlay/customFilters/customFilterCalendar/customFilterCalendarFunctions";
import { configureRoadAccidentsInfoRequestBody, configureRoadAccidentsMapFilterString, configureRoadAccidentsTableFilterString } from "./filtersFunctions";
import { RadioButton } from "primereact/radiobutton";
import { delay } from "../../../../../features/dataFunctions/dataFunctions";

const filtersIcon = require('../../../../../assets/images/icons/filters-icon.svg').default

// Объект конфигурации фильтра "Вид ДТП"
export const roadAccidentTypeOptions: any = {
    hitAnimals: {
        name: 'Наезд на животных',
        typeId: 90
    },
    crash: {
        name: 'Столкновение',
        typeId: 1
    },
    overturn: {
        name: 'Опрокидывание',
        typeId: 2
    },
    hitStationaryVehicle: {
        name: 'Наезд на стоящее транспортное средство',
        typeId: 3
    },
    hitObstacle: {
        name: 'Наезд на препятствие',
        typeId: 4
    },
    hitPedestrian: {
        name: 'Наезд на пешехода',
        typeId: 5
    },
    hitCyclist: {
        name: 'Наезд на велосипедиста',
        typeId: 6
    },
    hitHorseDrawnVehicle: {
        name: 'Наезд на гужевой транспорт',
        typeId: 7
    },
    passengerFall: {
        name: 'Падение пассажира',
        typeId: 8
    },
    others: {
        name: 'Иной вид ДТП',
        typeId: 999999
    },
}

// Объект конфигурации фильтра "Наличие пострадавших"
const roadAccidentDeathTollOptions: any = {
    noVictims: "Нет пострадавших",
    withVictims: "Есть пострадавшие",
    withFatalities: "Есть погибшие"
}

// Объект конфигурации фильтра "Условия освещения"
export const roadAccidentLightConditionOptions: any = {
    daylight: {
        name: 'Светлое время суток',
        lightConditionId: 1
    },
    twilight: {
        name: 'Сумерки',
        lightConditionId: 5
    },
    darkLightingIsOn: {
        name: 'Тёмное время суток, освещение включено',
        lightConditionId: 2
    },
    darkLightingIsOff: {
        name: 'Тёмное время суток, освещение не включено',
        lightConditionId: 3
    },
    darkNoLighting: {
        name: 'Тёмное время суток, освещение отсутствует',
        lightConditionId: 4
    }
}

// Объект конфигурации фильтра "Состояние покрытия"
export const roadAccidentCoverStateOptions: any = {
    dry: {
        name: 'Сухое',
        coverStateId: 1
    },
    wet: {
        name: 'Мокрое',
        coverStateId: 2
    },
    dirty: {
        name: 'Загрязнённое',
        coverStateId: 7
    },
    freshSurfaceTreatment: {
        name: 'Свежеуложенная поверхностная обработка',
        coverStateId: 8
    },
    snowy: {
        name: 'Заснеженное',
        coverStateId: 3
    },
    iceSlick: {
        name: 'Гололедица',
        coverStateId: 4
    },
    deicingMaterial: {
        name: 'Обработанное противогололёдным материалом',
        coverStateId: 5
    },
    snowRoll: {
        name: 'Со снежным накатом',
        coverStateId: 6
    },
    waterCovered: {
        name: 'Залитое (покрытое) водой',
        coverStateId: 9
    },
    dusty: {
        name: 'Пыльное',
        coverStateId: 10
    },
}

// Объект конфигурации фильтра "Погодные условия"
export const roadAccidentWeatherConditionOptions: any = {
    clear: {
        name: 'Ясно',
        weatherConditionCode: 'Я'
    },
    cloudy: {
        name: 'Пасмурно',
        weatherConditionCode: 'П'
    },
    fog: {
        name: 'Туман',
        weatherConditionCode: 'Т'
    },
    rain: {
        name: 'Дождь',
        weatherConditionCode: 'Д'
    },
    snowfall: {
        name: 'Снегопад',
        weatherConditionCode: 'С'
    },
    highTemperature: {
        name: 'Температура выше +30⁰ С',
        weatherConditionCode: '+'
    },
    lowTemperature: {
        name: 'Температура ниже -30⁰ С',
        weatherConditionCode: '-'
    },
    snowstorm: {
        name: 'Метель',
        weatherConditionCode: 'М'
    },
    hurricaneWind: {
        name: 'Ураганный ветер',
        weatherConditionCode: 'У'
    },
}

// Компонент - информационное окно/фильтры для карты ДТП
export default function RoadAccidentsOverlay() {
    const dispatch = useDispatch();
    const tableUnderMapIsShown = useAppSelector(state => state.contentHeader.tableUnderMapIsShown)
    let { Count, DeathRoll, DeathRollChildren, WoundedCount, WoundedCountChildren } = useAppSelector(state => state.roadAccidents.roadAccidentsInfo) ?? {}
    const roadAccidentsActiveFiltersTabs = useAppSelector(state => state.roadAccidents.activeFiltersTabs)
    const roadAccidentsMapFilters = useAppSelector(state => state.roadAccidents.roadAccidentsMapFilters)
    let ignoreRoadAccidentsTypeMapFilter = roadAccidentsMapFilters.roadAccidentType.ignoreRoadAccidentType
    let ignoreRoadAccidentsLightMapFilter = roadAccidentsMapFilters.lightCondition.ignoreLightCondition
    let ignoreRoadAccidentsDeathTollMapFilter = roadAccidentsMapFilters.deathToll === "ignoreDeathToll"
    let ignoreRoadAccidentsCoverMapFilter = roadAccidentsMapFilters.coverState.ignoreCoverState
    let ignoreRoadAccidentsWeatherMapFilter = roadAccidentsMapFilters.weatherCondition.ignoreWeatherCondition
    let ignoreRoadAccidentsRaionMapFilter = roadAccidentsMapFilters.raions?.ignoreRaions
    const [roadAccidentDates, setRoadAccidentDates] = useState<any>(roadAccidentsMapFilters?.date?.map((date: any) => new Date(date)) ?? null);
    const [roadAccidentsFilterOpen, setRoadAccidentsFilterOpen] = useState<boolean>(false)
    const [roadAccidentsInfoLoading, setRoadAccidentsInfoLoading] = useState<boolean>(true)
    const [roadAccidentsInfoError, setRoadAccidentsInfoError] = useState<boolean>(false)
    const [raions, setRaions] = useState<any>([]);
    const [fetchRaionsError, setFetchRaionsError] = useState<boolean>(false)
    const [fetchingRaions, setFetchingRaions] = useState<boolean>(false)
    let calendarRef: any = useRef()
    let calendarDivRef: any = useRef()
    const currentConfig = getItemWebStorage('currentConfig')

    // Запрос на получение количества ДТП при изменении примененных фильтров
    useEffect(() => {
        fetchRoadAccidentsInfo()
    }, [JSON.stringify(roadAccidentsMapFilters)])

    useEffect(() => {
        configureRoadAccidentsMapFilterString(roadAccidentsMapFilters)
        configureRoadAccidentsTableFilterString(roadAccidentsMapFilters)
    }, [roadAccidentsMapFilters])

    useEffect(() => {
        fetchRaions(null, true)
    }, [])

    // обработчик для изменения состояния фильтров ДТП только при заполнении двух дат из промежутка
    useEffect(() => {
        if (roadAccidentDates && roadAccidentDates[1]) {
            let localState: any = {}
            Object.assign(localState, store.getState().roadAccidents.roadAccidentsMapFilters)
            let convertedRoadAccidentDates = roadAccidentDates.map((item: any) => convertDate(item))
            setItemWebStorage('roadAccidentsMapFilters', { ...localState, date: convertedRoadAccidentDates })
            dispatch(setRoadAccidentsMapFilters({ ...roadAccidentsMapFilters, date: convertedRoadAccidentDates }))
        }
        if (roadAccidentDates === null) {
            let localState: any = {}
            Object.assign(localState, store.getState().roadAccidents.roadAccidentsMapFilters)
            setItemWebStorage('roadAccidentsMapFilters', { ...localState, date: null })
            dispatch(setRoadAccidentsMapFilters({ ...roadAccidentsMapFilters, date: null }))
        }
    }, [roadAccidentDates])

    // изменение списка открытых фильтров ДТП
    function changeRoadAccidentsFiltersActiveTabs(event: any) {
        dispatch(setRoadAccidentsActiveFiltersTabs(event.index))
        setItemWebStorage('roadAccidentsMapFiltersActiveTabs', event.index)
    }

    // запрос списка районов для фильтра
    async function fetchRaions(event?: any, firstRender?: any) {
        setFetchRaionsError(false)
        setFetchingRaions(true)
        let apiUrl = currentConfig?.irosRestApiUrl
        const token = store.getState().auth.tokens.app
        let url = `${apiUrl}/Dicts/Raions`
        if (event?.target?.value) {
            url += `?$filter=(position('${event?.target?.value}', Name) gt 0)`
        }
        try {
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const raions = response.data.value;
            setRaions(raions)
            setFetchingRaions(false)
            if (firstRender) {
                let allRaionIds = raions.map((raion: any) => raion.RaionId)
                dispatch(setRoadAccidentsAllRaionMapFilterValues(allRaionIds))
            }
        } catch (error) {
            setFetchingRaions(false)
            setFetchRaionsError(true)
        }
    }

    // очищение всех фильтров ДТП
    function handleClearAllFiltersRoadAccidents() {
        const roadAccidentFiltersInitialState = {
            date: null,
            deathToll: "ignoreDeathToll",
            roadAccidentType: {
                ignoreRoadAccidentType: true
            },
            lightCondition: {
                ignoreLightCondition: true
            },
            coverState: {
                ignoreCoverState: true
            },
            weatherCondition: {
                ignoreWeatherCondition: true
            },
            raions: {
                ignoreRaions: true
            },
        }
        setItemWebStorage('roadAccidentsMapFilters', roadAccidentFiltersInitialState)
        dispatch(setRoadAccidentsMapFilters(roadAccidentFiltersInitialState))
        setRoadAccidentDates(null)
    }

    // функция для подсчета всех активных полей для конкретного фильтра ДТП
    function countAllActiveValuesForFilter(localState: any, field: string) {
        return Object.keys(localState[field]).filter((key: any) => (key != `ignore${capitalize(field)}` && localState[field][key])).length
    }
    // функция для подсчета всех активных полей для всех фильтров ДТП
    function countAllActiveValuesForAllFilters() {
        let localState: any = store.getState().roadAccidents.roadAccidentsMapFilters
        let numberOfActiveFilters
        numberOfActiveFilters = !numberOfActiveFilters ? 0 : numberOfActiveFilters
        if (localState.date) {
            numberOfActiveFilters += 1
        }
        if (localState.deathToll !== "ignoreDeathToll") {
            numberOfActiveFilters += 1
        }
        if (!localState.roadAccidentType.ignoreRoadAccidentType) {
            numberOfActiveFilters += countAllActiveValuesForFilter(localState, 'roadAccidentType')
        }
        if (!localState.lightCondition.ignoreLightCondition) {
            numberOfActiveFilters += countAllActiveValuesForFilter(localState, 'lightCondition')
        }
        if (!localState.coverState.ignoreCoverState) {
            numberOfActiveFilters += countAllActiveValuesForFilter(localState, 'coverState')
        }
        if (!localState.weatherCondition.ignoreWeatherCondition) {
            numberOfActiveFilters += countAllActiveValuesForFilter(localState, 'weatherCondition')
        }
        if (!localState.raions.ignoreRaions) {
            numberOfActiveFilters += countAllActiveValuesForFilter(localState, 'raions')
        }
        return numberOfActiveFilters
    }

    // функция для очищения одного фильтра ДТП
    function handleClearFiltersRoadAccidents(event: any, type: any) {
        event.stopPropagation()
        event.preventDefault()
        let localState: any = {}
        Object.assign(localState, store.getState().roadAccidents.roadAccidentsMapFilters)
        if (type === 'date') {
            setRoadAccidentDates(null)
        }
        else if (type === 'deathToll') {
            setItemWebStorage('roadAccidentsMapFilters', { ...localState, [type]: `ignore${capitalize(type)}` })
            dispatch(setRoadAccidentsMapFilters({ ...roadAccidentsMapFilters, [type]: `ignore${capitalize(type)}` }))
        }
        else {
            setItemWebStorage('roadAccidentsMapFilters', { ...localState, [type]: { [`ignore${capitalize(type)}`]: true } })
            dispatch(setRoadAccidentsMapFilters({ ...roadAccidentsMapFilters, [type]: { [`ignore${capitalize(type)}`]: true } }))
        }
    }

    // Функция для получения шаблона заголовка аккордеона
    function getAccordionHeaderRoadAccidentTemplate(name: string, type: string) {
        let localState: any = store.getState().roadAccidents.roadAccidentsMapFilters
        let showClearFiltersButton
        let numberOfActiveFilters
        if (type === 'date') {
            showClearFiltersButton = localState[type]
            numberOfActiveFilters = 1
        }
        else if (type === 'deathToll'){
            showClearFiltersButton = localState[type] !== `ignore${capitalize(type)}`
            numberOfActiveFilters = 1
        }
        else {
            showClearFiltersButton = !localState[type][`ignore${capitalize(type)}`]
            numberOfActiveFilters = countAllActiveValuesForFilter(localState, type)
        }
        return (
            <div className="map-overlay-filter-header-div">
                <span className="map-overlay-filter-header-name p-overlay-badge">
                    {name}
                    {showClearFiltersButton &&
                        <Badge value={numberOfActiveFilters}></Badge>
                    }
                </span>
                {showClearFiltersButton &&
                    <Button onClick={(event) => handleClearFiltersRoadAccidents(event, type)} className="map-overlay-filter-header-clear-but" severity="secondary" icon="pi pi-filter-slash" rounded outlined />
                }
            </div>
        )
    }
    // функция для применения фильтра ДТП
    function onCheckRoadAccidentFilters(fieldName: string, event: any, type: string) {
        let localState: any = {}
        Object.assign(localState, store.getState().roadAccidents.roadAccidentsMapFilters)
        if (type === 'date') {
            setRoadAccidentDates(event.value)
        }
        else if (type === 'deathToll') {
            setItemWebStorage('roadAccidentsMapFilters', { ...localState, [type]: fieldName })
            dispatch(setRoadAccidentsMapFilters({ ...roadAccidentsMapFilters, [type]: fieldName }))
        } else {
            let localValue: any = {}
            Object.assign(localValue, localState?.[type])
            Object.assign(localValue, { [fieldName]: event.checked })
            if (fieldName !== `ignore${capitalize(type)}`) {
                Object.assign(localValue, { [`ignore${capitalize(type)}`]: false })
            }
            setItemWebStorage('roadAccidentsMapFilters', { ...localState, [type]: localValue })
            dispatch(setRoadAccidentsMapFilters({ ...roadAccidentsMapFilters, [type]: localValue }))
        }
    }
    // функция для запроса количества ДТП
    async function fetchRoadAccidentsInfo() {
        setRoadAccidentsInfoLoading(true)
        setRoadAccidentsInfoError(false)
        let hasNoActiveAccidentTypes = Object.keys(roadAccidentsMapFilters.roadAccidentType).every(key => roadAccidentsMapFilters.roadAccidentType[key] == false)
        let hasNoActiveLightConditions = Object.keys(roadAccidentsMapFilters.lightCondition).every(key => roadAccidentsMapFilters.lightCondition[key] == false)
        let hasNoActiveCoverStates = Object.keys(roadAccidentsMapFilters.coverState).every(key => roadAccidentsMapFilters.coverState[key] == false)
        let hasNoActiveWeatherConditions = Object.keys(roadAccidentsMapFilters.weatherCondition).every(key => roadAccidentsMapFilters.weatherCondition[key] == false)
        let hasNoActiveRaions = Object.keys(roadAccidentsMapFilters.raions).every(key => roadAccidentsMapFilters.raions[key] == false)
        if (hasNoActiveAccidentTypes || hasNoActiveLightConditions || hasNoActiveCoverStates || hasNoActiveWeatherConditions || hasNoActiveRaions) {
            setRoadAccidentsInfoLoading(false)
            dispatch(setRoadAccidentsInfo(
                {
                    Count: 0,
                    DeathRoll: 0,
                    DeathRollChildren: 0,
                    WoundedCount: 0,
                    WoundedCountChildren: 0
                }
            ))
        }
        else {
            try {
                const token = store.getState().auth.tokens.app
                let url = `${currentConfig.irosRestApiUrl}/objects/accidentAmount`
                let body = configureRoadAccidentsInfoRequestBody(roadAccidentsMapFilters)
                const response = await axios.post(url, body, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                setRoadAccidentsInfoLoading(false)
                dispatch(setRoadAccidentsInfo(response?.data))
            } catch (error) {
                setRoadAccidentsInfoLoading(false)
                setRoadAccidentsInfoError(true)
            }
        }
    }

    // Классы для контроля отображения фильтров
    // - Класс всего окна информации для карты ДТП
    let mapOverlayRoadAccidentsClassName = classNames({
        "map-overlay-road-accidents": true,
        "map-overlay": true,
        "filters-div-opened": roadAccidentsFilterOpen
    })

    // - Класс для галочки типа ДТП
    let roadAccidentTypeCheckBoxClassName = classNames({
        "filter-checkbox-disabled": ignoreRoadAccidentsTypeMapFilter
    })
    // - Класс для текста типа ДТП
    let roadAccidentTypeLabelClassName = classNames({
        "ms-2": true,
        "filter-label-disabled": ignoreRoadAccidentsTypeMapFilter
    })

    // - Класс для галочки условий освещения
    let roadAccidentLightCheckBoxClassName = classNames({
        "filter-checkbox-disabled": ignoreRoadAccidentsLightMapFilter
    })
    // - Класс для текста условий освещения
    let roadAccidentLightLabelClassName = classNames({
        "ms-2": true,
        "filter-label-disabled": ignoreRoadAccidentsLightMapFilter
    })

    // - Класс для галочки состояния покрытия
    let roadAccidentCoverCheckBoxClassName = classNames({
        "filter-checkbox-disabled": ignoreRoadAccidentsCoverMapFilter
    })
    // - Класс для текста состояния покрытия
    let roadAccidentCoverLabelClassName = classNames({
        "ms-2": true,
        "filter-label-disabled": ignoreRoadAccidentsCoverMapFilter
    })

    // - Класс для галочки условий погоды
    let roadAccidentWeatherCheckBoxClassName = classNames({
        "filter-checkbox-disabled": ignoreRoadAccidentsWeatherMapFilter
    })
    // - Класс для текста условий погоды
    let roadAccidentWeatherLabelClassName = classNames({
        "ms-2": true,
        "filter-label-disabled": ignoreRoadAccidentsWeatherMapFilter
    })

    // - Класс для галочки района
    let raionCheckBoxClassName = classNames({
        "filter-checkbox-disabled": ignoreRoadAccidentsRaionMapFilter
    })
    // - Класс для текста района
    let raionLabelClassName = classNames({
        "ms-2": true,
        "filter-label-disabled": ignoreRoadAccidentsRaionMapFilter
    })

    return (
        <>
            <div className={mapOverlayRoadAccidentsClassName}>
                {roadAccidentsInfoLoading
                    ?
                    <div className="map-overlay-info-block-loading">
                        <span className="spinner-border spinner-border-sm me-2 ms-2" role="status" aria-hidden="true"></span>
                        <span>Загрузка...</span>
                    </div>
                    :
                    <>
                        {roadAccidentsInfoError
                            ?
                            <div className="map-overlay-info-block-loading">
                                <span>Ошибка загрузки.</span>
                            </div>
                            :
                            <div className="map-overlay-info-block">
                                <div className="values-col">
                                    <div>
                                        <span className="info-hint-label-field">Всего ДТП:</span>
                                        <span>{Count}</span>
                                    </div>
                                    <div>
                                        <span className="info-hint-label-field">Погибших:</span>
                                        <span>{DeathRoll}</span>
                                    </div>
                                    <div>
                                        <span className="info-hint-label-field">в т.ч. детей (до 18 лет):</span>
                                        <span>{DeathRollChildren}</span>
                                    </div>
                                    <div>
                                        <span className="info-hint-label-field">Раненых:</span>
                                        <span>{WoundedCount}</span>
                                    </div>
                                    <div>
                                        <span className="info-hint-label-field">в т.ч. детей (до 18 лет):</span>
                                        <span>{WoundedCountChildren}</span>
                                    </div>
                                </div>
                            </div>
                        }
                    </>
                }

                <div className="buttons-div">
                    {roadAccidentsFilterOpen &&
                        <Button onClick={handleClearAllFiltersRoadAccidents} className="clear-all-filters">Сбросить все фильтры</Button>
                    }
                    <div className="filters-button-div p-overlay-badge" onClick={() => { setRoadAccidentsFilterOpen(!roadAccidentsFilterOpen) }}>
                        <div className="filter-button-image-div">
                            <img src={filtersIcon} />
                        </div>
                        <span>Фильтры</span>
                        {(!roadAccidentsFilterOpen && countAllActiveValuesForAllFilters() != undefined) &&
                            <Badge value={countAllActiveValuesForAllFilters()}></Badge>
                        }
                    </div>
                </div>
                {roadAccidentsFilterOpen &&
                    <div className={"filters-div" + (tableUnderMapIsShown ? " in-half-size-map" : '')}>
                        <Accordion multiple activeIndex={roadAccidentsActiveFiltersTabs} onTabChange={(event) => changeRoadAccidentsFiltersActiveTabs(event)}>
                            {/* Фильтр - Дата */}
                            <AccordionTab header={getAccordionHeaderRoadAccidentTemplate('Дата', 'date')} className="road-accidents-date-accordion">
                                <div className="date-calendar" ref={calendarDivRef}>
                                    <Calendar
                                        value={roadAccidentDates}
                                        ref={calendarRef}
                                        onChange={(event: any) => onCheckRoadAccidentFilters('date', event, 'date')}
                                        inline
                                        selectOtherMonths
                                        selectionMode="range"
                                        maxDate={new Date()}
                                    />
                                </div>
                                {(roadAccidentDates && roadAccidentDates[1]) ?
                                    <>
                                        {(convertDate(roadAccidentDates[0]) === convertDate(roadAccidentDates[1])) ?
                                            <div className="show-date-filter-div">
                                                <input type="text" key='singleDate' value={`${formatDate(convertDate(roadAccidentDates[1]))}`} readOnly></input>
                                            </div>
                                            :
                                            <div className="show-date-filter-div">
                                                <input type="text" key='datesRange' value={`${formatDate(convertDate(roadAccidentDates[0]))} - ${formatDate(convertDate(roadAccidentDates[1]))}`} readOnly></input>
                                            </div>
                                        }
                                    </>
                                    :
                                    <>
                                        {(roadAccidentDates && !roadAccidentDates[0] && !roadAccidentDates[1]) || !roadAccidentDates &&
                                            <div className="show-date-filter-div">
                                                <input type="text" key='chooseFirstDate' placeholder="Выберите начальную дату" readOnly></input>
                                            </div>
                                        }
                                        {(roadAccidentDates && !roadAccidentDates[1]) &&
                                            <div className="show-date-filter-div">
                                                <input type="text" key='chooseSecondDate' placeholder="Выберите конечную дату" readOnly></input>
                                            </div>
                                        }
                                    </>
                                }
                                <div className="date-buttons">
                                    <Button className="date-filter-button today" onClick={() => setRoadAccidentDates(getTodayDateFilterRange)} outlined={!checkToday(roadAccidentDates)}>
                                        Сегодня
                                    </Button>
                                    <Button className="date-filter-button yesterday" onClick={() => setRoadAccidentDates(setYesterdayDateFilterRange)} outlined={!checkYesterday(roadAccidentDates)}>
                                        Вчера
                                    </Button>
                                    <Button className="date-filter-button this-week" onClick={() => setRoadAccidentDates(setThisWeekDateFilterRange)} outlined={!checkThisWeek(roadAccidentDates)}>
                                        Текущая неделя
                                    </Button>
                                    <Button className="date-filter-button last-week" onClick={() => setRoadAccidentDates(setLastWeekDateFilterRange)} outlined={!checkLastWeek(roadAccidentDates)}>
                                        Прошлая неделя
                                    </Button>
                                    <Button className="date-filter-button last-week" onClick={() => setRoadAccidentDates(setThisMonthDateFilterRange)} outlined={!checkThisMonth(roadAccidentDates)}>
                                        Текущий месяц
                                    </Button>
                                    <Button className="date-filter-button last-week" onClick={() => setRoadAccidentDates(setLastMonthDateFilterRange)} outlined={!checkLastMonth(roadAccidentDates)}>
                                        Прошлый месяц
                                    </Button>
                                    <Button className="date-filter-button last-week" onClick={() => setRoadAccidentDates(setThisYearDateFilterRange)} outlined={!checkThisYear(roadAccidentDates)}>
                                        Текущий год
                                    </Button>
                                    <Button className="date-filter-button last-week" onClick={() => setRoadAccidentDates(setLastYearDateFilterRange)} outlined={!checkLastYear(roadAccidentDates)}>
                                        Прошлый год
                                    </Button>
                                </div>
                            </AccordionTab>
                            {/* Фильтр - Вид ДТП */}
                            <AccordionTab header={getAccordionHeaderRoadAccidentTemplate('Вид ДТП', 'roadAccidentType')}>
                                {Object.keys(roadAccidentTypeOptions).map((key => {
                                    let checked
                                    if (roadAccidentsMapFilters?.hasOwnProperty('roadAccidentType') && roadAccidentsMapFilters?.roadAccidentType.hasOwnProperty(key)) {
                                        checked = roadAccidentsMapFilters?.roadAccidentType[key]
                                    } else {
                                        checked = false
                                    }
                                    return (
                                        <div className="map-hint-filters-checkbox-div">
                                            <PrimeReactCheckBox
                                                className={roadAccidentTypeCheckBoxClassName}
                                                id={key}
                                                inputId={`${key}RoadAccidents`}
                                                name={`${key}`}
                                                onChange={(event: any) => onCheckRoadAccidentFilters(`${key}`, event, 'roadAccidentType')}
                                                checked={checked}
                                            />
                                            <label htmlFor={`${key}`} className={roadAccidentTypeLabelClassName}>{roadAccidentTypeOptions[key].name}</label>
                                        </div>
                                    )
                                }))}
                                <div className="map-hint-filters-checkbox-div">
                                    <PrimeReactCheckBox
                                        className={roadAccidentTypeCheckBoxClassName}
                                        inputId="noRoadAccidentType"
                                        name="noRoadAccidentType"
                                        onChange={(event: any) => onCheckRoadAccidentFilters(`noRoadAccidentType`, event, 'roadAccidentType')}
                                        checked={roadAccidentsMapFilters?.roadAccidentType?.noRoadAccidentType}
                                    />
                                    <label htmlFor="noRoadAccidentType" className={roadAccidentTypeLabelClassName}>Не указан</label>
                                </div>
                                <div className="map-hint-filters-checkbox-div">
                                    <PrimeReactCheckBox
                                        inputId="ignoreRoadAccidentType"
                                        onChange={(event: any) => onCheckRoadAccidentFilters(`ignoreRoadAccidentType`, event, 'roadAccidentType')}
                                        name="ignoreRoadAccidentType"
                                        checked={ignoreRoadAccidentsTypeMapFilter}
                                    />
                                    <label htmlFor="ignoreRoadAccidentType" className="ms-2">Не учитывать</label>
                                </div>
                            </AccordionTab>
                            {/* Фильтр - Наличие пострадавших */}
                            <AccordionTab header={getAccordionHeaderRoadAccidentTemplate('Наличие пострадавших', 'deathToll')}>
                                {Object.entries(roadAccidentDeathTollOptions).map((([key, name]: any) => {
                                    let checked = roadAccidentsMapFilters?.deathToll == key
                                    return (
                                        <div className="map-hint-filters-radio-button-div">
                                            <RadioButton inputId={key} name="deathToll" value={key} onChange={(event) => onCheckRoadAccidentFilters(`${key}`, event, 'deathToll')} checked={checked} />
                                            <label htmlFor={key} className="ms-2">{name}</label>
                                        </div>
                                    )
                                }))}
                                <div className="map-hint-filters-radio-button-div">
                                    <RadioButton inputId="ignoreDeathToll" name="ignoreDeathToll" value="ignoreDeathToll" onChange={(event) => onCheckRoadAccidentFilters('ignoreDeathToll', event, 'deathToll')} checked={ignoreRoadAccidentsDeathTollMapFilter} />
                                    <label htmlFor="ignoreDeathToll" className="ms-2">Не учитывать</label>
                                </div>
                            </AccordionTab>
                            {/* Фильтр - Состояние освещения */}
                            <AccordionTab header={getAccordionHeaderRoadAccidentTemplate('Состояние освещения', 'lightCondition')}>
                                {Object.keys(roadAccidentLightConditionOptions).map((key => {
                                    let checked
                                    if (roadAccidentsMapFilters?.hasOwnProperty('lightCondition') && roadAccidentsMapFilters?.lightCondition.hasOwnProperty(key)) {
                                        checked = roadAccidentsMapFilters?.lightCondition[key]
                                    } else {
                                        checked = false
                                    }
                                    return (
                                        <div className="map-hint-filters-checkbox-div">
                                            <PrimeReactCheckBox
                                                className={roadAccidentLightCheckBoxClassName}
                                                inputId={`${key}RoadAccidents`}
                                                name={`${key}`}
                                                onChange={(event: any) => onCheckRoadAccidentFilters(`${key}`, event, 'lightCondition')}
                                                checked={checked}
                                            />
                                            <label htmlFor={`${key}`} className={roadAccidentLightLabelClassName}>{roadAccidentLightConditionOptions[key].name}</label>
                                        </div>
                                    )
                                }))}
                                <div className="map-hint-filters-checkbox-div">
                                    <PrimeReactCheckBox
                                        className={roadAccidentLightCheckBoxClassName}
                                        inputId="noLightCondition"
                                        name="noLightCondition"
                                        onChange={(event: any) => onCheckRoadAccidentFilters(`noLightCondition`, event, 'lightCondition')}
                                        checked={roadAccidentsMapFilters?.lightCondition?.noLightCondition}
                                    />
                                    <label htmlFor="noLightCondition" className={roadAccidentLightLabelClassName}>Не указан</label>
                                </div>
                                <div className="map-hint-filters-checkbox-div">
                                    <PrimeReactCheckBox
                                        inputId="ignoreLightCondition"
                                        onChange={(event: any) => onCheckRoadAccidentFilters(`ignoreLightCondition`, event, 'lightCondition')}
                                        name="ignoreLightCondition"
                                        checked={ignoreRoadAccidentsLightMapFilter}
                                    />
                                    <label htmlFor="ignoreLightCondition" className="ms-2">Не учитывать</label>
                                </div>
                            </AccordionTab>
                            {/* Фильтр - Состояние покрытия */}
                            <AccordionTab header={getAccordionHeaderRoadAccidentTemplate('Состояние покрытия', 'coverState')}>
                                {Object.keys(roadAccidentCoverStateOptions).map((key => {
                                    let checked
                                    if (roadAccidentsMapFilters?.hasOwnProperty('coverState') && roadAccidentsMapFilters?.coverState.hasOwnProperty(key)) {
                                        checked = roadAccidentsMapFilters?.coverState[key]
                                    } else {
                                        checked = false
                                    }
                                    return (
                                        <div className="map-hint-filters-checkbox-div">
                                            <PrimeReactCheckBox
                                                className={roadAccidentCoverCheckBoxClassName}
                                                inputId={`${key}RoadAccidents`}
                                                name={`${key}`}
                                                onChange={(event: any) => onCheckRoadAccidentFilters(`${key}`, event, 'coverState')}
                                                checked={checked}
                                            />
                                            <label htmlFor={`${key}`} className={roadAccidentCoverLabelClassName}>{roadAccidentCoverStateOptions[key].name}</label>
                                        </div>
                                    )
                                }))}
                                <div className="map-hint-filters-checkbox-div">
                                    <PrimeReactCheckBox
                                        className={roadAccidentCoverCheckBoxClassName}
                                        inputId="noCoverState"
                                        name="noCoverState"
                                        onChange={(event: any) => onCheckRoadAccidentFilters(`noCoverState`, event, 'coverState')}
                                        checked={roadAccidentsMapFilters?.coverState?.noCoverState}
                                    />
                                    <label htmlFor="noCoverState" className={roadAccidentCoverLabelClassName}>Не указан</label>
                                </div>
                                <div className="map-hint-filters-checkbox-div">
                                    <PrimeReactCheckBox
                                        inputId="ignoreCoverState"
                                        onChange={(event: any) => onCheckRoadAccidentFilters(`ignoreCoverState`, event, 'coverState')}
                                        name="ignoreCoverState"
                                        checked={ignoreRoadAccidentsCoverMapFilter}
                                    />
                                    <label htmlFor="ignoreCoverState" className="ms-2">Не учитывать</label>
                                </div>
                            </AccordionTab>
                            {/* Фильтр - Погодные условия */}
                            <AccordionTab header={getAccordionHeaderRoadAccidentTemplate('Погодные условия', 'weatherCondition')}>
                                {Object.keys(roadAccidentWeatherConditionOptions).map((key => {
                                    let checked
                                    if (roadAccidentsMapFilters?.hasOwnProperty('weatherCondition') && roadAccidentsMapFilters?.weatherCondition.hasOwnProperty(key)) {
                                        checked = roadAccidentsMapFilters?.weatherCondition[key]
                                    } else {
                                        checked = false
                                    }
                                    return (
                                        <div className="map-hint-filters-checkbox-div">
                                            <PrimeReactCheckBox
                                                className={roadAccidentWeatherCheckBoxClassName}
                                                inputId={`${key}RoadAccidents`}
                                                name={`${key}`}
                                                onChange={(event: any) => onCheckRoadAccidentFilters(`${key}`, event, 'weatherCondition')}
                                                checked={checked}
                                            />
                                            <label htmlFor={`${key}`} className={roadAccidentWeatherLabelClassName}>{roadAccidentWeatherConditionOptions[key].name}</label>
                                        </div>
                                    )
                                }))}
                                <div className="map-hint-filters-checkbox-div">
                                    <PrimeReactCheckBox
                                        className={roadAccidentWeatherCheckBoxClassName}
                                        inputId="noWeatherCondition"
                                        name="noWeatherCondition"
                                        onChange={(event: any) => onCheckRoadAccidentFilters(`noWeatherCondition`, event, 'weatherCondition')}
                                        checked={roadAccidentsMapFilters?.weatherCondition?.noWeatherCondition}
                                    />
                                    <label htmlFor="noWeatherCondition" className={roadAccidentWeatherLabelClassName}>Не указан</label>
                                </div>
                                <div className="map-hint-filters-checkbox-div">
                                    <PrimeReactCheckBox
                                        inputId="ignoreWeatherCondition"
                                        onChange={(event: any) => onCheckRoadAccidentFilters(`ignoreWeatherCondition`, event, 'weatherCondition')}
                                        name="ignoreWeatherCondition"
                                        checked={ignoreRoadAccidentsWeatherMapFilter}
                                    />
                                    <label htmlFor="ignoreWeatherCondition" className="ms-2">Не учитывать</label>
                                </div>
                            </AccordionTab>
                            <AccordionTab header={getAccordionHeaderRoadAccidentTemplate("Район", 'raions')}>
                                <div className="filter-list-checkbox">
                                    <div className="map-hint-filters-checkbox-div">
                                        <PrimeReactCheckBox
                                            inputId="ignoreRaions"
                                            onChange={(event: any) => onCheckRoadAccidentFilters(`ignoreRaions`, event, 'raions')}
                                            name="ignoreRaions"
                                            checked={ignoreRoadAccidentsRaionMapFilter}
                                        />
                                        <label htmlFor="ignoreRaions" className="ms-2">Не учитывать</label>
                                    </div>
                                    <input onChange={(e: any) => delay(() => fetchRaions(e), 300)} className="list-checkbox-search"></input>
                                    {fetchingRaions
                                        ?
                                        <div className="m-2">
                                            <span className="spinner-border spinner-border-sm me-2 ms-2" role="status" aria-hidden="true"></span>
                                            <span>Загрузка...</span>
                                        </div>
                                        :
                                        <>
                                            {fetchRaionsError
                                                ?
                                                <div className="m-2">
                                                    <span>Ошибка при загрузке списка районов.</span>
                                                </div>
                                                :
                                                <>
                                                    <div className="list-checkbox with-search-container">
                                                        <div className="map-hint-filters-checkbox-div">
                                                            <PrimeReactCheckBox
                                                                className={raionCheckBoxClassName}
                                                                inputId="noRaion"
                                                                name="noRaion"
                                                                onChange={(event: any) => onCheckRoadAccidentFilters(`noRaion`, event, 'raions')}
                                                                checked={roadAccidentsMapFilters?.raions?.noRaion}
                                                            />
                                                            <label htmlFor="noRaion" className={raionLabelClassName}>Не указан</label>
                                                        </div>
                                                        {raions.map(((raion: any) => {
                                                            let checked
                                                            if (roadAccidentsMapFilters?.hasOwnProperty('raions') && roadAccidentsMapFilters.raions.hasOwnProperty(`${raion.RaionId}`)) {
                                                                checked = roadAccidentsMapFilters.raions[raion.RaionId]
                                                            } else {
                                                                checked = false
                                                            }
                                                            return (
                                                                <div className="map-hint-filters-checkbox-div">
                                                                    <PrimeReactCheckBox
                                                                        className={raionCheckBoxClassName}
                                                                        inputId={`${raion.RaionId}`}
                                                                        onChange={(event: any) => onCheckRoadAccidentFilters(`${raion.RaionId}`, event, 'raions')}
                                                                        name={`${raion.RaionId}`}
                                                                        checked={checked}
                                                                    />
                                                                    <label htmlFor={`${raion.RaionId}`} className={raionLabelClassName}>р-н. {raion.Name}</label>
                                                                </div>
                                                            )
                                                        }))}
                                                    </div>
                                                </>
                                            }
                                        </>
                                    }
                                </div>
                            </AccordionTab>
                        </Accordion>
                    </div>
                }
            </div>
        </>
    )
}
